import React from 'react'
import { SVGIconProps } from '../types'
const SvgBarrels = ({ size = 16, ...props }: SVGIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="currentColor"
    {...props}
  >
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h16v16H0z" />
      <path
        fill="#233745"
        d="M12.89 6.419v1.853l.017.006a.7.7 0 0 1 .493.668v.34a.7.7 0 0 1-.493.669l-.017.004v1.011l.017.005a.7.7 0 0 1 .493.669v.34a.7.7 0 0 1-.493.668l-.017.005v1.18q-1.637.675-3.275.675t-3.276-.675v-1.18l-.016-.004a.7.7 0 0 1-.493-.67v-.339a.7.7 0 0 1 .493-.669l.016-.006V9.96l-.016-.005a.7.7 0 0 1-.493-.669v-.34a.7.7 0 0 1 .493-.668l.016-.006V6.42a8.2 8.2 0 0 0 3.238.674q1.656 0 3.313-.674M3.21 3.856c.899.383 1.598.603 2.534.66.058.003.16.004.256.004h.137c.103.001.163.003.092.01-.731.077-.38 1.376-.485 3.44-.567.125-.817 1.894 0 2.245.14.06.115.177.115.515 0 .095-.027.135-.247.234-.38.17-.098.925-.324.925-.767 0-1.313-.3-2.078-.615v-1.179l-.169-.053a.48.48 0 0 1-.341-.446v-.69c0-.2.137-.38.341-.445l.169-.053v-1.01l-.169-.054a.48.48 0 0 1-.341-.446v-.69c0-.2.137-.379.341-.445l.169-.053zm6.413.404q1.366 0 2.728.47a.8.8 0 0 1 .54.757v.122c-.998.373-2.288.675-3.28.675-1.003 0-2.27-.295-3.272-.675v-.12a.8.8 0 0 1 .541-.757 8.4 8.4 0 0 1 2.743-.472M6.493 1.9q1.366 0 2.728.47a.8.8 0 0 1 .54.756v.123c-.998.373-2.288.674-3.28.674-1.003 0-2.27-.295-3.271-.674v-.121a.8.8 0 0 1 .54-.757A8.4 8.4 0 0 1 6.493 1.9"
      />
    </g>
  </svg>
)
export default SvgBarrels
